(function () {
  'use strict';

  window.UnifiedTrackingConfig = {
    version: '2.3.0',

    debug: false,
    consentRequired: true,

    providers: {
      ga4: true,
      clarity: false,

      meta: {
        enabled: true,

        pixelId:
          '2301873400351189',

        pageView: true,

        eventMap: {
          phone_grooming:
            'Lead',

          phone_hotel:
            'Lead',

          phone_veterinar:
            'Lead',

          email_hotel:
            'Lead',

          contact_form_submit:
            'Lead',

          whatsapp_click:
            'Lead'
        },

        capi: {
          enabled: true,

          endpoint:
            'https://labute-fericite-meta-capi.vlad-elias-cp.workers.dev/events',

          testEventCode:
            '',

          keepalive: true,

          includeFbp: true,
          includeFbc: true
        }
      },

      tiktok: false,
      linkedin: false
    },

    providerConsent: {
      ga4: 'analytics',
      clarity: 'analytics',
      meta: 'marketing',
      tiktok: 'marketing',
      linkedin: 'marketing'
    },

    rules: {
      enabled: true,

      defaultDecision:
        'allow',

      definitions: [
        {
          id:
            'route_leads_to_ga4_and_meta',

          description:
            'Route lead events to GA4 and Meta.',

          enabled: true,

          priority: 100,

          events: [
            'phone_grooming',
            'phone_hotel',
            'phone_veterinar',
            'email_hotel',
            'contact_form_submit',
            'whatsapp_click'
          ],

          actions: [
            {
              type:
                'route',

              routes: [
                'ga4',
                'meta'
              ]
            }
          ]
        },

        {
          id:
            'route_engagement_to_ga4',

          description:
            'Route engagement events to GA4 only.',

          enabled: true,

          priority: 90,

          events: [
            'section_view'
          ],

          actions: [
            {
              type:
                'route',

              routes: [
                'ga4'
              ]
            }
          ]
        }
      ]
    },

    events: {
      phone_grooming: {
        category:
          'lead',

        service:
          'grooming',

        conversion:
          true
      },

      phone_hotel: {
        category:
          'lead',

        service:
          'hotel',

        conversion:
          true
      },

      phone_veterinar: {
        category:
          'lead',

        service:
          'veterinar',

        conversion:
          true
      },

      email_hotel: {
        category:
          'lead',

        service:
          'hotel',

        conversion:
          true
      },

      contact_form_submit: {
        category:
          'lead',

        service:
          'general',

        conversion:
          true
      },

      whatsapp_click: {
        category:
          'lead',

        service:
          'dynamic',

        conversion:
          true
      },

      section_view: {
        category:
          'engagement',

        service:
          'dynamic',

        conversion:
          false
      }
    },

    pages: {
      grooming: {
        paths: [
          '/pages/grooming'
        ]
      },

      hotel: {
        paths: [
          '/pages/pet-hotel'
        ]
      },

      veterinar: {
        paths: [
          '/pages/veterinary'
        ]
      },

      contact: {
        paths: [
          '/pages/contact'
        ]
      }
    },

    phones: {
      grooming: {
        display:
          '0732 837 167',

        normalized: [
          '0732837167',
          '40732837167'
        ]
      },

      hotel: {
        display:
          '0732 837 167',

        normalized: [
          '0732837167',
          '40732837167'
        ]
      },

      veterinar: {
        display:
          '0711 030 440',

        normalized: [
          '0711030440',
          '40711030440'
        ]
      }
    }
  };
})();